export default __webpack_public_path__ + "static/media/landing-page-head-img-3.f12255fb.jpg";